{
  "version": 1,
  "asset_id": "1fd4d428-2e3d-42bd-bbf2-99ff904b7f02",
  "project_id": "ab945133-766b-45c0-8595-d741bb5019f6",
  "url": "/__l5e/assets-v1/1fd4d428-2e3d-42bd-bbf2-99ff904b7f02/toxicological-risk-assessment-tra.jpg",
  "r2_key": "a/v1/ab945133-766b-45c0-8595-d741bb5019f6/1fd4d428-2e3d-42bd-bbf2-99ff904b7f02/toxicological-risk-assessment-tra.jpg",
  "original_filename": "toxicological-risk-assessment-tra.jpg",
  "size": 725383,
  "content_type": "image/jpeg",
  "created_at": "2026-09-09T10:30:50Z"
}
